import React, { Component } from 'react';

class ReviewBar extends Component {
	render() {
		return (
			<div className="review__drawer">
				<div className="review__drawer--content">
					<div className="review-card">
						<div className="rating__stars">
							<div className="stars d-inline-block">
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star-o"></i>
							</div>
						</div>
						<span>Julia, Singapore</span>
						<h5>I fell in love with yours from day one!</h5>
						<p>“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“</p>
						<img src="/images/review-customer.png" />
					</div>
					<div className="review-card">
						<div className="rating__stars">
							<div className="stars d-inline-block">
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star-o"></i>
							</div>
						</div>
						<span>Julia, Singapore</span>
						<h5>I fell in love with yours from day one!</h5>
						<p>“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“</p>
						<img src="/images/review-customer.png" />
					</div>
					<div className="review-card">
						<div className="rating__stars">
							<div className="stars d-inline-block">
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star"></i>
								<i className="fa fa-2x fa-star-o"></i>
							</div>
						</div>
						<span>Julia, Singapore</span>
						<h5>I fell in love with yours from day one!</h5>
						<p>“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“It's not that I wasn't pretty. It’s that I wasn’t confident enough to see myself that way.”“</p>
						<img src="/images/review-customer.png" />
					</div>
				</div>
				<div className="review__drawer--button">
					<div className="vertical-text"><i className="fa fa-2x fa-star"></i> REVIEWS</div>
				</div>
			</div>
		);
	}
}


export default ReviewBar;